/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChartPie2 = createReactComponent("chart-pie-2", "IconChartPie2", [
  ["path", { d: "M12 3v9h9", key: "svg-0" }],
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-1" }]
]);

export { IconChartPie2 as default };
//# sourceMappingURL=IconChartPie2.js.map
